import PropTypes from "prop-types";

import MDBox from "components/MDBox";

/** Font.icons của game, thứ tự PHẢI khớp các ô 15px trong public/game/font-icons.png (pet/icons.png). */
const ICONS = [
  "(ngoc)",
  "(dau)",
  "(thoc)",
  "(vang)",
  "(str)",
  "(agi)",
  "(int)",
  "(atk)",
  "(def)",
  "(hp)",
  "(mp)",
  "(water)",
  "(thunder)",
  "(rock)",
  "(fire)",
  "(dark)",
  "(tree)",
  "(light)",
  "(sao)",
  "(chien)",
  "(bthu)",
  "(codo)",
  "(coxanh)",
  "(nha)",
  "(nguoi)",
  "(saoden)",
  "(chienluc)",
  "(nluong)",
  "(diem)",
  "(lua)",
  "(chimang)",
  "(stchimang)",
  "(netranh)",
  "(chinhxac)",
  "(giamthu)",
];

const CELL = 15;
const SPRITE = `${process.env.PUBLIC_URL}/game/font-icons.png`;
const INDEX = Object.fromEntries(ICONS.map((token, i) => [token, i]));
const PATTERN = new RegExp(`(${ICONS.map((t) => t.replace(/[()]/g, "\\$&")).join("|")})`);

/** Chữ của game có ký hiệu như (sao), (saoden), (ngoc): vẽ thành icon giống trong game. */
function GameText({ text, size }) {
  if (!text) return null;
  const parts = String(text).split(PATTERN);
  if (parts.length === 1) return text;
  const scale = size / CELL;
  return parts.map((part, i) => {
    const index = INDEX[part];
    if (index === undefined) return part;
    return (
      <MDBox
        key={i}
        component="span"
        title={part}
        display="inline-block"
        width={size}
        height={size}
        sx={{
          verticalAlign: "text-bottom",
          backgroundImage: `url(${SPRITE})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: `${ICONS.length * size}px ${size}px`,
          backgroundPosition: `-${index * CELL * scale}px 0`,
          imageRendering: "pixelated",
        }}
      />
    );
  });
}

GameText.defaultProps = { text: "", size: 15 };
GameText.propTypes = {
  text: PropTypes.string,
  size: PropTypes.number,
};

export default GameText;
